export default (array, index, deep) => {
  for (var i = 0, n = index.length, copy = deep ? JSON.parse(JSON.stringify(array)) : new Array(n); i < n; ++i) {
    copy[i] = array[index[i]];
  }
  return copy;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/crossfilter2/src/permute.js
// module id = hHA2
// module chunks = 0